export const MAINT_STATUS = {
  submitted: { label: "تم التقديم", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  assigned: { label: "تم تعيين الفني", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  in_progress: { label: "قيد التنفيذ", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  completed: { label: "تم الإنجاز", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "مرفوض", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const ORDER_STATUS = {
  new: { label: "طلب جديد", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  confirmed: { label: "تم التأكيد", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  assigned: { label: "تم تعيين الفني", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  on_the_way: { label: "في الطريق", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  completed: { label: "تم التسليم", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled: { label: "ملغي", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const USER_STATUS = {
  new: { label: "لم يكمل التسجيل", cls: "bg-stone-50 text-stone-600 border-stone-200" },
  pending: { label: "بانتظار الاعتماد", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  approved: { label: "معتمد", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "مرفوض", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const ROLE_LABEL = { admin: "مدير النظام", employee: "موظف", customer: "مالك" };
export const PERM_LABEL = { maintenance: "مهام الصيانة", orders: "طلبات المتجر" };
export const URGENCY = { normal: "عادي", urgent: "عاجل", emergency: "طارئ" };
export const MAINT_FLOW = ["submitted", "assigned", "in_progress", "completed"];
export const ORDER_FLOW = ["new", "confirmed", "assigned", "on_the_way", "completed"];
